import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import SubHeader from 'component/SubHeader';
import Menu from 'component/Menu';
import Footer from 'component/Footer';

import './PageActivity.scss';

type Props = {
  testPath: string,
}

const PageActivity: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // Effect
  useEffect(() => {
    // タイトルなど
    // document.title = '7 ACTIVITIES';

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  return (
    <div id="PageActivity">
      <Header />
      <Menu />
      <SubHeader active={2} />

      <div className="topTitle">
        <h2 className="c-h2">７つのアクティビティで見る</h2>
      </div>

      <div className="lead">本当に役立つオフィスをつくるヒント「7アクティビティ」。</div>

      <div className="fig">
        <ul>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area17.html'} >
              <p className="title"><span>オペレーションワーク</span></p>
              <p className="lead">会社やチームの雰囲気を感じながら雑談や相談、ソロワークをするスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area15.html'} >
              <p className="title"><span>チームビルディング</span></p>
              <p className="lead">多彩なアクティビティを通して互いを理解し、エンゲージメントを高めるスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area14.html'} >
              <p className="title"><span>チームシンキング</span></p>
              <p className="lead">アイデアを視覚化・一覧化して共有しより深く議論をするスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area16.html'} >
              <p className="title"><span>高集中ワーク</span></p>
              <p className="lead">オフィスでしか実現できない環境で、ひとつのことに没頭して取り組むスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area19.html'} >
              <p className="title"><span>特殊・専門ワーク</span></p>
              <p className="lead">五感を使うことや、特殊設備や環境を必要とする専門的なワークをするスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area18.html'} >
              <p className="title"><span>社外関係構築</span></p>
              <p className="lead">自社のビジョンや強みを伝え、共感を得るなどで信頼関係を築くスペース。</p>
            </Link>
          </li>
          <li>
            <Link to={'/digital/fair2021/showroom/floor4/area20.html'} >
              <p className="title"><span>高機密性ワーク</span></p>
              <p className="lead">セキュアな環境でコミュニケーションをするなどで、プロジェクトを遂行するスペース。</p>
            </Link>
          </li>
          <li className="blnak"></li>
        </ul>
      </div>

      <Footer />
    </div>
  );
}

export default PageActivity;
